"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ArticleBoxArea = _interopRequireDefault(require("../../../SIA-WEBSITE/ArticleBoxArea/ArticleBoxArea"));
var _Pagination = _interopRequireDefault(require("../../../Pagination/Pagination"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.marterpreisArticles {\n  width: fit-content;\n  margin: auto;\n  padding-left: 0px; }\n\n@media (max-width: 66rem) {\n  .marterpreisArticles {\n    padding-left: 8px; } }\n\n@media (max-width: 42rem) {\n  .marterpreisArticles {\n    padding: 8px; } }\n";
  const fileName = "MarterpreisArticles_MarterpreisArticles";
  const element = document.querySelector("style[data-sass-component='MarterpreisArticles_MarterpreisArticles']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const MarterpreisArticles = _ref => {
  let {
    articles,
    lang,
    translate
  } = _ref;
  const [page, setPage] = (0, _react.useState)(1);
  const [itemsPerPage, setItemsPerPage] = (0, _react.useState)(10);
  const items = articles.map(article => ({
    ...article,
    main_tag: article?.main_tag?.length > 0 ? article.main_tag[0].name : '',
    alias: '/' + article.id
  })).slice((page - 1) * itemsPerPage, page * itemsPerPage);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "marterpreisArticles sia-padding-04-top"
  }, /*#__PURE__*/_react.default.createElement(_ArticleBoxArea.default, {
    items: items,
    lang: lang,
    translate: translate,
    showTitle: false
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "sia-text-12 sia-padding-02-top"
  }, /*#__PURE__*/_react.default.createElement(_Pagination.default, {
    items: Array.from({
      length: articles.length
    }, (v, i) => i),
    onChange: (newPage, perPageLimit) => {
      setPage(newPage);
      setItemsPerPage(perPageLimit);
    },
    translate: translate,
    page: page
  })));
};
var _default = exports.default = MarterpreisArticles;